"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[342],{

/***/ 98342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/dataContext.js
var dataContext = __webpack_require__(54491);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./Layout/partials/tixyLogo.js + 1 modules
var tixyLogo = __webpack_require__(57805);
// EXTERNAL MODULE: ./context/languageContext.js
var languageContext = __webpack_require__(34579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./Layout/Footer/Footer.elements.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position:absolute;\n  bottom:0;\n  left:0;\n  right:0;\n  box-sizing: border-box;\n  //background-color:#0D1016;\n  //background-color: #111111;\n  background-color: #1A1A1B;\n  padding:0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  height:130px;\n  z-index: 99;\n  padding-top: 20px;\n  \n  @media screen and (max-width: 1000px) {\n    width: 100%;\n    justify-content: space-between;\n    padding: 1rem 0 1rem 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1000px;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 1000px;\n  margin: auto;\n  height: 50px;\n  @media screen and (max-width: 1000px) {\n    flex-direction: column;\n    margin: 0px auto 0 auto;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  width: auto;\n  height: 30px;\n  gap:20px;\n  @media screen and (max-width: 1000px) {\n    \n    margin: 0px auto 0 auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ffffff99;\n  margin-bottom: 10px;\n  font-size: 12px;\n  letter-spacing: .5px;\n  width: 80%;\n  font-weight: 400;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #FFFFFF;\n  margin-bottom: 20px;\n  margin-top: 5px;\n  font-size: 1rem;\n  width: 80%;\n  text-align: center;\n  text-decoration: underline;  \n\n  &:hover{\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #FFFFFF75;\n  font-size: 12px;\n  width: fit-content;\n  text-align: center;  \n  :hover{\n    cursor:pointer;\n    color: #FFFFFF;    \n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 300px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 150px;\n  height: 40px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  width: 80%;\n  border-bottom: 1px solid #C5C5C5;\n  height: 1px;\n\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #FFFFFF;\n  font-size: 25px;\n  padding-left: 4px;\n  padding-right: 4px;\n\n  &:hover{\n    color:#17cba4;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a8109ab-0"
})(_templateObject());
var SocialMedia = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-8a8109ab-1"
})(_templateObject1());
var SocialMediaWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a8109ab-2"
})(_templateObject2());
var TermsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a8109ab-3"
})(_templateObject3());
var WebsiteRights = styled_components_browser_esm/* default.small.withConfig */.ZP.small.withConfig({
    componentId: "sc-8a8109ab-4"
})(_templateObject4());
var SignOutButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8a8109ab-5"
})(_templateObject5());
var TermsAndServices = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8a8109ab-6"
})(_templateObject6());
var SocialIcons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a8109ab-7"
})(_templateObject7());
var LogoDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a8109ab-8"
})(_templateObject8());
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a8109ab-9"
})(_templateObject9());
var SocialIconLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8a8109ab-10"
})(_templateObject10());

;// CONCATENATED MODULE: ./Layout/Footer/Footer1.js









function Footer() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useContext)(languageContext/* default */.Z), language = ref.language, logout = ref.logout;
    var currentUser = (0,react.useContext)(dataContext/* default */.Z).currentUser;
    function handleLogout() {
        return _handleLogout.apply(this, arguments);
    }
    function _handleLogout() {
        _handleLogout = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                logout();
                router.push("/");
                return [
                    2
                ];
            });
        });
        return _handleLogout.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoDiv, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tixyLogo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                (currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid.includes("admin")) || router.pathname === "/" || !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WebsiteRights, {
                    children: [
                        " ",
                        "\xa9".concat(new Date().getFullYear(), " Tixy Ab All rights reserved")
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignOutButton, {
                    onClick: handleLogout,
                    children: [
                        " ",
                        language == "swe" ? "Logga ut" : "Sign out"
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Footer1 = (Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/robotHead.png
/* harmony default export */ var robotHead = ({"src":"/_next/static/media/robotHead.492ce94e.png","height":313,"width":371,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAGFBMVEUXu6YSy6USy6USy6USzKUSyqITy6QRxqJpyuFVAAAACHRSTlMCbF+FeDRQHWleAj8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAvSURBVHicFcq3EcBAEAOxpTl+/x1rhBjggzM4khSjDbbSBJKw+88Z86SHqNxa/QAQ+ACS0wcpfgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./components/utils/firebase/firebase.js + 5 modules
var firebase = __webpack_require__(81229);
// EXTERNAL MODULE: ./node_modules/firebase/firestore/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(36100);
;// CONCATENATED MODULE: ./Layout/Header/NavSwitch.js



function NavSwitch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    NavSwitch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavSwitch_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 20px;\n"
    ]);
    NavSwitch_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavSwitch_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f1f1f150;\n  transition: 0.4s;\n  border-radius: 34px;\n  //opacity: ",
        ';\n\n  &:before {\n    position: absolute;\n    content: "";\n    height: 32px;\n    width: 32px;\n    left: ',
        ";\n    bottom: -7px;\n    background-color: ",
        ";;\n    transition: 0.4s;\n    border-radius: 50%;\n  }\n"
    ]);
    NavSwitch_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavSwitch_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 23px;\n  height: 23px;\n  left:10px;\n  bottom: 1px;\n  transition: transform linear  200ms;\n  opacity: ",
        ";\n  transform: ",
        ";\n"
    ]);
    NavSwitch_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavSwitch_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  &:checked + ",
        " {\n    background-color: #13CBA4;\n  }\n\n  &:focus + ",
        " {\n    box-shadow: 0 0 1px #13CBA4;\n  }\n\n  &:checked + ",
        ":before {\n    transform: translateX(26px);\n  }\n"
    ]);
    NavSwitch_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavSwitch_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 12px;\n  color: ",
        ";\n  font-size: 1rem;\n  font-weight: 400;\n"
    ]);
    NavSwitch_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var ToggleSwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-161c789e-0"
})(NavSwitch_templateObject());
var Switch = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-161c789e-1"
})(NavSwitch_templateObject1());
var Slider = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-161c789e-2"
})(NavSwitch_templateObject2(), function(props) {
    return props.isOn ? "1" : "0.5";
}, function(props) {
    return props.isOn ? "5px" : "-2px";
}, function(props) {
    return props.isOn ? "#404040" : "#ffffff";
});
var RobotImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-161c789e-3"
})(NavSwitch_templateObject3(), function(props) {
    return props.isOn ? "1" : "0";
}, function(props) {
    return props.isOn ? "translateX(26px)" : "none";
});
var Checkbox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-161c789e-4"
})(NavSwitch_templateObject4(), Slider, Slider, Slider);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-161c789e-5"
})(NavSwitch_templateObject5(), function(props) {
    return props.isOn ? "#f1f1f1" : "#ffffff90";
});
var ToggleSwitch = function(param) {
    var labelText = param.labelText, isOn = param.isOn;
    var handleToggle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var docRef;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        docRef = (0,index_esm/* doc */.JU)(firebase.db, "clients/speed/tasks/autoValues");
                        return [
                            4,
                            (0,index_esm/* updateDoc */.r7)(docRef, {
                                autoQueues: !isOn
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleToggle() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleSwitchContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Switch, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        checked: isOn,
                        onChange: handleToggle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                        isOn: isOn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RobotImageWrapper, {
                        isOn: isOn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: robotHead,
                            alt: "Robot",
                            layout: "fill",
                            objectFit: "contain"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                isOn: isOn,
                children: labelText
            })
        ]
    });
};
/* harmony default export */ var NavSwitch = (ToggleSwitch);

;// CONCATENATED MODULE: ./Layout/Header/NavBarAdmin.js


function NavBarAdmin_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: ",
        ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: ",
        ";\n  height: 64px;\n  max-height: 64px;\n  z-index: 99;\n  transition: 0.8s linear;\n  box-sizing: border-box;\n"
    ]);
    NavBarAdmin_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavBarAdmin_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1460px;\n"
    ]);
    NavBarAdmin_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavBarAdmin_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  width:auto;\n  flex: 1;\n  height:100%;\n  gap:24px;\n\n  @media screen and (max-width:1400px) {\n    padding-right: 20px;\n  }\n\n"
    ]);
    NavBarAdmin_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavBarAdmin_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #F1F1F1;\n    font-weight: 400;\n    height: 1.2rem;\n    width: auto;\n    font-size: 1.05rem;\n    transition: all 0.1s ease-in-out;\n\n    &:hover {\n      color: #F1F1F190;\n      border-bottom:0.5px solid #F1F1F190;\n      cursor: pointer;\n    }\n"
    ]);
    NavBarAdmin_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavBarAdmin_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100px;\n  height: 40px;\n  cursor: pointer;\n\n  @media screen and (max-width:1400px) {\n    margin-left: 15px;\n  }\n\n  @media screen and (max-width:700px) {\n    width: 80px;\n    height: 35px;\n  }\n\n"
    ]);
    NavBarAdmin_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25af04c5-0"
})(NavBarAdmin_templateObject(), function(props) {
    return props.position ? props.position : "fixed";
}, function(props) {
    return props.background;
});
var HeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25af04c5-1"
})(NavBarAdmin_templateObject1());
var ButtonsInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25af04c5-2"
})(NavBarAdmin_templateObject2());
var MiddleButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-25af04c5-3"
})(NavBarAdmin_templateObject3());
var NavBarAdmin_LogoDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25af04c5-4"
})(NavBarAdmin_templateObject4());
function NavbarAdmin(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useContext)(dataContext/* default */.Z), currentUser = ref.currentUser, autoValues = ref.autoValues;
    var uidPath = currentUser.uid.split("-")[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
            borderColor: "#00000000",
            background: "#00000000",
            position: "absolute",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderInner, {
                children: [
                    router.pathname.includes("/admin") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarAdmin_LogoDiv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tixyLogo/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsInner, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavSwitch, {
                                labelText: "K\xf6er",
                                isOn: autoValues.autoQueues
                            }),
                            router.pathname.includes("/admin") ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleButton, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(uidPath, "/admin"),
                                    children: " Admin "
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 2 modules
var Stack = __webpack_require__(31536);
// EXTERNAL MODULE: ./node_modules/@mui/material/ToggleButton/ToggleButton.js + 1 modules
var ToggleButton = __webpack_require__(96420);
// EXTERNAL MODULE: ./node_modules/@mui/material/ToggleButtonGroup/ToggleButtonGroup.js + 2 modules
var ToggleButtonGroup = __webpack_require__(33454);
;// CONCATENATED MODULE: ./components/utils/Toggle/index.js








function ToggleButtonNotEmpty(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useContext)(languageContext/* default */.Z), language = ref.language, handlelanguage = ref.handlelanguage;
    var sx = {
        padding: "8px",
        background: "transparent",
        border: "none",
        "&.Mui-selected, &.Mui-selected:hover": {
            color: "white",
            borderBottom: "1px solid #ffffff",
            borderRadius: "0px",
            paddingBottom: "3px",
            paddingTop: "3px",
            margin: "auto",
            background: "transparent"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        spacing: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleButtonGroup/* default */.Z, {
            value: language,
            exclusive: true,
            onChange: handlelanguage,
            "aria-label": "text language",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                    value: "swe",
                    "aria-label": "Swedish",
                    sx: sx,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/sweden.svg",
                        alt: "British flag",
                        height: 30,
                        width: 30
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                    value: "eng",
                    "aria-label": "English",
                    sx: sx,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/britain.svg",
                        alt: "swedish flag",
                        height: 30,
                        width: 30
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./Layout/Header/NavbarBasic.js






function NavbarBasic(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(0), scroll = ref[0], setScroll = ref[1];
    var handleScroll = function() {
        var position = window.pageYOffset;
        setScroll(position);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    //console.log(scroll)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
            background: scroll > 100 ? backgroundColor : "transparent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarAdmin_LogoDiv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tixyLogo/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonsInner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButtonNotEmpty, {})
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./Layout/Header/NavbarUser.js






function NavBarUser(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
            background: "#0a0a0a",
            borderColor: "#ffffff00",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarAdmin_LogoDiv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tixyLogo/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonsInner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButtonNotEmpty, {})
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/hamburger-react/dist-esm/Squash.js + 1 modules
var Squash = __webpack_require__(27022);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Home.js
var Home = __webpack_require__(76638);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
;// CONCATENATED MODULE: ./Layout/Sidebar/sidebarItems.js



function sidebarItems(uid, language) {
    var pathArr = uid.split("-");
    return [
        {
            title: language == "swe" ? "Verksamhet" : "Overview",
            link: "/".concat(pathArr[0], "/").concat(pathArr[1]),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsSpeedometer2 */.REm, {})
        },
        {
            title: language == "swe" ? "Statistik" : "Statistics",
            link: "/".concat(pathArr[0], "/").concat(pathArr[1], "/workers"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsFillPeopleFill */.rVC, {})
        },
        {
            title: language == "swe" ? "\xd6versikt" : "Dashboard",
            link: "/".concat(pathArr[0], "/").concat(pathArr[1], "/dashboard"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsFillBarChartFill */._Ey, {})
        },
        {
            title: language == "swe" ? "Lager" : "Warehouse",
            link: "/".concat(pathArr[0], "/").concat(pathArr[1], "/warehouse"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsLayersFill */.Mun, {
                sx: {
                    fontSize: "inherit",
                    m: 0,
                    p: 0
                }
            })
        },
        {
            title: language == "swe" ? "Hem" : "Home",
            link: "/".concat(pathArr[0], "/"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home/* default */.Z, {
                sx: {
                    fontSize: "inherit",
                    m: 0,
                    p: 0
                }
            })
        }, 
    ];
}

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExitToApp.js
var ExitToApp = __webpack_require__(49123);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./components/utils/reuseable/SxProps.js
var SxProps = __webpack_require__(43759);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
;// CONCATENATED MODULE: ./Layout/Sidebar/signOutButton.js







function signOutButton_SignOutButton(param) {
    var sidebar = param.sidebar;
    var ref = (0,react.useContext)(languageContext/* default */.Z), logout = ref.logout, language = ref.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: sidebar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function() {
                return logout();
            },
            loadingPosition: "end",
            sx: SxProps/* sxPropButton */.kw,
            fullWidth: true,
            variant: "contained",
            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitToApp/* default */.Z, {
                sx: {
                    fontSize: 18
                }
            }),
            children: language == "swe" ? "Logga ut" : "Sign out"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            size: "large",
            onClick: function() {
                return logout();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitToApp/* default */.Z, {
                sx: {
                    width: 35,
                    height: 35,
                    color: "white"
                }
            })
        })
    });
}
/* harmony default export */ var signOutButton = (signOutButton_SignOutButton);

;// CONCATENATED MODULE: ./Layout/Sidebar/sidebarMain.js

function sidebarMain_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;  \n  align-items: center;\n  position: fixed;\n  box-sizing: border-box;\n  min-height: 100%;\n  top:0;\n  z-index: 100;\n  transition: linear 300ms;\n  //background: #0D1016;\n  background-color: #1A1A1B;\n  gap: 20px;\n  margin-top: 0px;\n  padding-top: 150px;\n\n  width: ",
        ";\n  left: ",
        ";\n\n\n  @media screen and (max-width:700px) {\n    padding-top: 50px;\n  }\n"
    ]);
    sidebarMain_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: ",
        ";\n    fill:1;\n    color:#F9F7F5;\n"
    ]);
    sidebarMain_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: ",
        ";;\n    color:#F9F7F5;\n    text-align: left;\n    transition: font-size 450ms;\n"
    ]);
    sidebarMain_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #17cba4;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 45px;\n  width: 100%;\n  text-decoration: none;\n  margin-bottom: 10px;\n"
    ]);
    sidebarMain_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #17cba4;\n  flex-direction: row;\n  justify-content: ",
        ";\n  align-items: center;\n  box-sizing: border-box;\n  height: 90%;\n  width: 90%;\n  text-decoration: none;\n  gap: ",
        ";\n  border-radius: 5px;\n  padding: ",
        ";\n\n  &:hover {\n    background-color: #ffffff50;\n    cursor: pointer;\n  }\n\n"
    ]);
    sidebarMain_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  width: 90%;\n  padding-bottom: 50px;\n"
    ]);
    sidebarMain_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    font-size: 1.6rem;\n    width:55px;\n    height:55px;\n    color:#F9F7F5;\n    z-index: 1000;\n    padding-top: 10px;\n    z-index: 101;\n    &:hover {\n        cursor: pointer;\n    }\n"
    ]);
    sidebarMain_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function sidebarMain_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:100%;\n    height:55px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n   flex-direction: row;\n   padding-left: 20px;\n"
    ]);
    sidebarMain_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var SidebarNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-54fe7c3a-0"
})(sidebarMain_templateObject(), function(param) {
    var sidebar = param.sidebar;
    return sidebar ? "185px" : "55px";
}, function(param) {
    var sidebar = param.sidebar, desktop = param.desktop;
    return desktop || sidebar ? "0px" : "-250px";
});
var TilesIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54fe7c3a-1"
})(sidebarMain_templateObject1(), function(param) {
    var sidebar = param.sidebar;
    return sidebar ? "1.2rem" : "2rem";
});
var TilesText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-54fe7c3a-2"
})(sidebarMain_templateObject2(), function(param) {
    var sidebar = param.sidebar;
    return sidebar ? "1.2rem" : "0rem";
});
var NavMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54fe7c3a-3"
})(sidebarMain_templateObject3());
var InnerNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54fe7c3a-4"
})(sidebarMain_templateObject4(), function(param) {
    var sidebar = param.sidebar;
    return sidebar ? "flex-start" : "center";
}, function(param) {
    var sidebar = param.sidebar;
    return sidebar ? "10px" : "0px";
}, function(param) {
    var sidebar = param.sidebar;
    return sidebar ? "0px 5px 0px 8px" : "0px";
});
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54fe7c3a-5"
})(sidebarMain_templateObject5());
var HamburgerMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54fe7c3a-6"
})(sidebarMain_templateObject6());
var TooggleMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54fe7c3a-7"
})(sidebarMain_templateObject7());
function Sidebar(param) {
    var currentUser = param.currentUser;
    var ref = (0,react.useState)(0), width = ref[0], setWidth = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setOpen = ref1[1];
    var language = (0,react.useContext)(languageContext/* default */.Z).language;
    var items = sidebarItems(currentUser.uid, language);
    (0,react.useEffect)(function() {
        setWidth(window.innerWidth);
        window.addEventListener("resize", function() {
            setWidth(window.innerWidth);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HamburgerMenu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Squash/* Squash */.v, {
                    toggled: isOpen,
                    toggle: setOpen,
                    size: 26
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarNav, {
                sidebar: isOpen,
                desktop: width > 1500,
                children: [
                    items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: item.link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMenu, {
                                onClick: function() {
                                    return setOpen(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerNav, {
                                    sidebar: isOpen,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TilesIcon, {
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TilesText, {
                                            sidebar: isOpen,
                                            children: item.title
                                        })
                                    ]
                                })
                            })
                        }, index);
                    }),
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooggleMenu, {
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButtonNotEmpty, {}),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signOutButton, {
                            sidebar: isOpen
                        })
                    })
                ]
            })
        ]
    });
}
;
/* harmony default export */ var sidebarMain = (Sidebar); //  width: ${({ sidebar }) => (sidebar ? '150px' : '50px')};
 //           <SidebarMobile currentUser={currentUser} sidebar={isOpen} setSidebar={setSidebar} language={language}></SidebarMobile>

;// CONCATENATED MODULE: ./Layout/Layout.js









function Layout(param) {
    var children = param.children;
    var ref = (0,react.useContext)(dataContext/* default */.Z), currentUser = ref.currentUser, authReady = ref.authReady;
    var history = (0,next_router.useRouter)();
    var currentPath = history.pathname;
    var uid = currentUser ? currentUser.uid : "";
    var pathArr = uid === null || uid === void 0 ? void 0 : uid.split("-");
    (0,react.useEffect)(function() {
        if (!authReady) {
            return;
        }
        if (uid) {
            if (currentPath === "/login" || currentPath === "/contact" || currentPath == "/") {
                var path = pathArr.includes("admin") ? "".concat(pathArr[0], "/").concat(pathArr[1]) : "".concat(pathArr[0]);
                history.push("/".concat(path));
            }
        } else if (currentPath != "/" && currentPath != "/login" && currentPath != "/contact") {
            history.push("/");
        }
    }, [
        currentUser,
        authReady
    ]);
    var UserAccessNav = function() {
        var uid = currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid;
        if (uid) {
            if (uid.includes("admin") && currentPath.includes("admin")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "contentSideBar",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarAdmin, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebarMain, {
                            currentUser: currentUser
                        }),
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1, {})
                    ]
                });
            } else if (uid.includes("admin")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarAdmin, {}),
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1, {})
                    ]
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarUser, {}),
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1, {})
                    ]
                });
            }
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "contentBasic",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarBasic, {}),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1, {})
                ]
            });
        }
    };
    // User signed out trying to access any page
    if (!uid && currentPath != "/login" && currentPath != "/contact" && currentPath != "/") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "globalLoader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://samherbert.net/svg-loaders/svg-loaders/ball-triangle.svg",
                alt: "loading image"
            })
        });
    }
    // User trying to access admin page for the user domain
    if (!uid.includes("admin") && currentPath.includes("admin") || !currentPath.includes(pathArr[0])) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "globalLoader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://samherbert.net/svg-loaders/svg-loaders/ball-triangle.svg",
                alt: "loading image"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: UserAccessNav()
    });
}


/***/ }),

/***/ 57805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TixyLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/algoflow.png
/* harmony default export */ var algoflow = ({"src":"/_next/static/media/algoflow.df5aa1cb.png","height":283,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEX///////////////////+Rd1MVAAAABXRSTlM6MT4lUMwAcNsAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAZSURBVHicBcEBAQAAAIIgrf5vDojUtAyGcgELABo/krDGAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./Layout/partials/tixyLogo.js





function TixyLogo() {
    // https://hackernoon.imgix.net/images/0*3IFEy-hfoIpgFjBl.gif
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            //layout="responsive"
            //objectFit={'contain'}
            src: algoflow,
            alt: "AlgoFlow logo"
        })
    });
}


/***/ }),

/***/ 43759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fc": function() { return /* binding */ MultisxValues; },
/* harmony export */   "GF": function() { return /* binding */ sxValuesBig; },
/* harmony export */   "IW": function() { return /* binding */ sxSelect; },
/* harmony export */   "Kd": function() { return /* binding */ sxPropLanding; },
/* harmony export */   "aL": function() { return /* binding */ sxAutoCompleteCustom; },
/* harmony export */   "cd": function() { return /* binding */ sxPropButtonDelete; },
/* harmony export */   "kw": function() { return /* binding */ sxPropButton; },
/* harmony export */   "sH": function() { return /* binding */ sxToggleButton; },
/* harmony export */   "te": function() { return /* binding */ sxValuesViewOnly; }
/* harmony export */ });
/* unused harmony exports sxValuesSmall, sxValues, sxCurrency, currencies, backSxProp */
var sxPropButton = {
    border: "1px solid #13B497",
    textTransform: "none",
    zIndex: 10,
    m: 0,
    background: "transparent",
    width: "100%",
    color: "#F9F7F5",
    fontSize: 20,
    borderRadius: "6px",
    "&:hover": {
        background: "#13B49750",
        borderColor: "#17cba4"
    },
    "&:disabled": {
        color: "white"
    }
};
var sxPropButtonDelete = {
    border: "1px solid #ff0f0f",
    textTransform: "none",
    zIndex: 10,
    m: 0,
    background: "transparent",
    width: "100%",
    color: "#F9F7F5",
    fontSize: 20,
    borderRadius: "6px",
    "&:hover": {
        background: "#ff0f0f50",
        borderColor: "#ff0f0f"
    },
    "&:disabled": {
        color: "white"
    }
};
var sxValuesSmall = {
    input: {
        color: "white",
        width: "77%"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "0.5px solid #888BA3",
            background: "rgba(230, 232, 250, 0.07)"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#118A74"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#878A9D"
    }
};
var sxValuesBig = {
    input: {
        color: "white",
        width: "95%"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "0.5px solid #888BA3",
            background: "rgba(230, 232, 250, 0.07)"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#118A74"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#F9F7F5"
    },
    "& .MuiOutlinedInput-root:hover": {
        "& > fieldset": {
            borderColor: "#118A74"
        }
    }
};
var sxAutoCompleteCustom = {
    input: {
        color: "white",
        width: "100%"
    },
    "& .MuiOutlinedInput-root": {
        height: 50,
        "& fieldset": {
            border: "0.5px solid #888BA3",
            background: "rgba(230, 232, 250, 0.07)"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#118A74"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#F9F7F5"
    },
    "& .MuiOutlinedInput-root:hover": {
        "& > fieldset": {
            borderColor: "#118A74"
        }
    },
    ".MuiAutocomplete-clearIndicator": {
        display: "none"
    }
};
var sxValuesViewOnly = {
    input: {
        color: "white",
        width: "95%"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "2px solid #118A74",
            background: "rgba(230, 232, 250, 0.07)"
        },
        "&.Mui-focused fieldset": {
            border: "2px solid #118A74"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#F9F7F5"
    },
    "& .MuiOutlinedInput-root:hover": {
        "& > fieldset": {
            border: "2px solid #118A74"
        }
    }
};
var sxValues = {
    ".css-i4bv87-MuiSvgIcon-root": {
        color: "#1CAA91"
    },
    input: {
        color: "white",
        width: "100%"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "0.5px solid #888BA3",
            background: "rgba(230, 232, 250, 0.07)"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#118A74"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#878A9D"
    },
    "&.MuiSvgIcon-root": {
        background: "#1CAA91"
    }
};
var MultisxValues = {
    background: "rgba(230, 232, 250, 0.07)",
    color: "#FFFFFF",
    ".css-1sqnrkk-MuiInputBase-input-MuiOutlinedInput-input": {
        color: "white"
    },
    "& .MuiOutlinedInput-root": {
        color: "#FFFFFF",
        "& fieldset": {
            border: "0.5px solid #888BA3"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#ff4d5a"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#878A9D"
    },
    p: 0,
    m: 0
};
var sxSelect = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#ffffff99"
    },
    "& .MuiSvgIcon-root": {
        fill: "#1CAA91"
    },
    color: "#F9F7F5",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent"
    },
    "& .label": {
        color: "#878A9D"
    },
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: "transparent"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    p: 0,
    m: 0,
    ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
        fontSize: 16,
        display: "flex",
        alignItems: "center",
        gap: 2,
        maxHeight: "50px",
        pt: 2,
        pb: 2
    }
};
var sxCurrency = {
    "& .css-ykkmtb-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root .MuiSvgIcon-root": {
        fill: "#1CAA91"
    },
    "& .MuiSvgIcon-root": {
        fill: "#118A74"
    },
    "& .MuiList-root .MuiMenu-list": {
        background: "#252835"
    },
    color: "#F9F7F5",
    "&.Mui-label": {
        color: ""
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#17cba4"
    },
    textAlign: "left",
    "& label": {
        color: "#878A9D"
    },
    ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select": {
        background: "#252735",
        border: "0.5px solid #888BA3"
    }
};
var currencies = [
    {
        value: "USD",
        label: "$"
    },
    {
        value: "EUR",
        label: "€"
    },
    {
        value: "SEK",
        label: "kr"
    }, 
];
var backSxProp = {
    border: "1px solid #13B497",
    textTransform: "none",
    zIndex: 10,
    m: 0,
    background: "transparent",
    width: 190,
    color: "#F9F7F5",
    minHeight: 50,
    fontSize: 20,
    borderRadius: "6px",
    "&:hover": {
        background: "#13B49750",
        borderColor: "#17cba4"
    }
};
var sxToggleButton = {
    color: "#F1F1F1",
    border: "1px solid rgba(230, 232, 250, 0.07)",
    "&.Mui-selected, &.Mui-selected:hover": {
        color: "white",
        backgroundColor: "rgba(230, 232, 250, 0.07)"
    }
};
var sxPropLanding = {
    input: {
        color: "white",
        width: "95%"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "0.5px solid #888BA3",
            background: "rgba(230, 232, 250, 0.07)"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#ff4d5a"
        }
    },
    "& label.Mui-focused": {
        color: "#F9F7F5"
    },
    "& label": {
        color: "#F9F7F5"
    },
    "& .MuiOutlinedInput-root:hover": {
        "& > fieldset": {
            borderColor: "#ff4d5a"
        }
    }
};


/***/ })

}]);